"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactI18next = require("react-i18next");
var _formatters = require("../../utils/formatters");
var _types = require("../../utils/types");
var _ImageIcon = _interopRequireDefault(require("../common/ImageIcon/ImageIcon"));
var _Stopwatch = _interopRequireDefault(require("../common/Stopwatch/Stopwatch"));
var _TypingIndicator = _interopRequireDefault(require("../TypingIndicator/TypingIndicator"));
require("./ChatListItem.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ChatListItem = function ChatListItem(_ref) {
  var id = _ref.id,
    user = _ref.user,
    text = _ref.text,
    unread = _ref.unread,
    date = _ref.date,
    campaign = _ref.campaign,
    active = _ref.active,
    typing = _ref.typing,
    timeUnattended = _ref.timeUnattended,
    warning = _ref.warning,
    onClick = _ref.onClick,
    typeMedia = _ref.typeMedia;
  var _useTranslation = (0, _reactI18next.useTranslation)('commons'),
    t = _useTranslation.t,
    i18n = _useTranslation.i18n;
  var lang = i18n.language.slice(0, 2);
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: id,
    className: "uin-list-item uin-chat-list-item ".concat(active ? 'active' : '', " ").concat(warning ? 'warning' : ''),
    onClick: onClick
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-lic-bar"
  }), unread > 0 && !active && /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-lic-dot"
  }), /*#__PURE__*/_react["default"].createElement(_ImageIcon["default"], {
    name: campaign.name,
    image: campaign.image
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-cli-body"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-cli-info"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "uin-cli-user c100"
  }, user), timeUnattended !== null && /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-lic-timeout"
  }, /*#__PURE__*/_react["default"].createElement(_Stopwatch["default"], {
    initialTime: timeUnattended
  })), /*#__PURE__*/_react["default"].createElement("time", {
    className: "c600",
    dateTime: date
  }, (0, _formatters.formatTimeOrDateShort)(date, lang)), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'uin-cli-unread' + (typeof unread === 'boolean' || unread <= 0 ? ' hidden' : '')
  }, (unread > 9 ? '+' : '') + Math.min(unread, 9)), /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon chat uin-lic-icon"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-cli-preview c500"
  }, typing ? /*#__PURE__*/_react["default"].createElement(_TypingIndicator["default"], {
    small: true
  }) : typeMedia === 'image' ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "multimediaIcon"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "chat-text-icon"
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon image"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "chat-text"
  }, t('whatsapp:image'))) : text || /*#__PURE__*/_react["default"].createElement("em", {
    className: "uin-lic-new-ph"
  }, t('new-convo')))));
};
ChatListItem.propTypes = {
  id: _propTypes["default"].number,
  user: _propTypes["default"].string.isRequired,
  campaign: _types.campaignType.isRequired,
  text: _propTypes["default"].string,
  unread: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].number]),
  date: _propTypes["default"].instanceOf(Date).isRequired,
  active: _propTypes["default"].bool,
  typing: _propTypes["default"].bool,
  timeUnattended: _propTypes["default"].instanceOf(Date),
  warning: _propTypes["default"].bool,
  onClick: _propTypes["default"].func.isRequired
};
ChatListItem.defaultProps = {
  unread: false,
  timeUnattended: null
};
var _default = exports["default"] = ChatListItem;


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/components/ChatListItem/ChatListItem.js
// module id = 1397
// module chunks = 0